import { render } from "./ChildrenList.vue?vue&type=template&id=30a9e57f"
import script from "./ChildrenList.vue?vue&type=script&lang=js"
export * from "./ChildrenList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__